import { useSelector } from "react-redux";
import BaseCard from "../../../components/ui/BaseCard";
import UserProfileLink from "../../../components/ui/UserProfileLink";

const LinkedCompaniesTable = () => {
  const company = useSelector((state) => state.authUser.value?.user?.company);

  return (
    <BaseCard className="py-2 px-4 sm:px-6 rounded-lg" elevation={1}>
      <div className="bg-light px-4 py-2 mt-2 mb-2 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Company</h6>
      </div>

      {company ? (
        <div className="px-4 pt-4 pb-2 flex items-center gap-4">
          {/* A company name opens its owner's profile - the company's "face" in the
              marketplace, same as everywhere else a company is listed. */}
          <UserProfileLink
            as="div"
            userId={company.ownerId}
            className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0"
            linkClassName="cursor-pointer"
          >
            <i className="fa-solid fa-building text-primary text-lg"></i>
          </UserProfileLink>
          <div>
            <UserProfileLink
              userId={company.ownerId}
              className="text-sm font-normal text-dark capitalize w-fit"
              linkClassName="cursor-pointer hover:text-primary hover:underline"
            >
              {company.name}
            </UserProfileLink>
            <p className="text-sm">ID: {company.id}</p>
          </div>
          <span className="ml-auto text-xs font-medium px-2 py-0.5 rounded-full bg-green-100 text-green-700">
            Linked
          </span>
        </div>
      ) : (
        <p className="px-4 py-4 text-sm">You are not linked to any company.</p>
      )}
    </BaseCard>
  );
};

export default LinkedCompaniesTable;
